<template>
  <div class="relative h-0">
    <transition
      enter-active-class="duration-300 delay-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-300"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div 
        v-show="isDisplayTooltip"
        :name="name"
        :class="'bg-indigo-600 text-white tooltip-Label flex absolute rounded-lg shadow-lg text-xs z-50 py-5 px-6 w-max-content w-max max-w-64 md:max-w-72 xxl:max-w-96 '+position"
        v-html="libelle"
      />
    </transition>
  </div>
</template>

<script>


export default {
  props:{
    isDisplayTooltip: Boolean,
    name: String,
    libelle: String,

    position:{
      type: String,
      required:false,
      default:'bottom-3 right-0',
    }
  }
};
</script>